/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { NotificationTypeFromJSON, NotificationTypeToJSON, } from './';
export function NotificationRecurringTestRequestFromJSON(json) {
    return NotificationRecurringTestRequestFromJSONTyped(json, false);
}
export function NotificationRecurringTestRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'eventStartDate': !exists(json, 'eventStartDate') ? undefined : (new Date(json['eventStartDate'])),
        'eventEndDate': !exists(json, 'eventEndDate') ? undefined : (json['eventEndDate'] === null ? null : new Date(json['eventEndDate'])),
        'interval': !exists(json, 'interval') ? undefined : json['interval'],
        'notifyAheadTime': !exists(json, 'notifyAheadTime') ? undefined : json['notifyAheadTime'],
        'type': !exists(json, 'type') ? undefined : NotificationTypeFromJSON(json['type']),
    };
}
export function NotificationRecurringTestRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'eventStartDate': value.eventStartDate === undefined ? undefined : (value.eventStartDate.toISOString()),
        'eventEndDate': value.eventEndDate === undefined ? undefined : (value.eventEndDate === null ? null : value.eventEndDate.toISOString()),
        'interval': value.interval,
        'notifyAheadTime': value.notifyAheadTime,
        'type': NotificationTypeToJSON(value.type),
    };
}
